import { Button, } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useMemo, useState } from "react";
import { Dashboard, Workspace } from "../../types/files";
import IntroductionRequestModal from "../modals/investors/IntroductionRequestModal";
import useBackwardsCompatible from "../../hooks/useBackwardsCompatible";

const useStyles = makeStyles((theme) => ({
    button: {
        minWidth: 100,
        width: '100%',
        height: 'fit-content',
        borderRadius: 32,
        fontSize: '0.95rem',
        fontWeight: 'bold',
        textTransform: 'none',
        transition: 'ease-in-out 300ms',
        "&.Mui-disabled": {
            backgroundColor: theme.colors.neutral[300],
        },
    },
}));

const RequestIntroButton: React.FC<{
    workspace?: Workspace,
    dashboard?: Dashboard,
}> = ({ workspace, dashboard }) => {
    const classes = useStyles();
    const [requestIntroModalOpen, setRequestIntroModalOpen] = useState<boolean>(false);
    const { dashboardSource } = useBackwardsCompatible();

    const source = useMemo(() => dashboardSource(dashboard), [dashboard, dashboardSource]);

    return (<>
        <Button variant="contained"
            className={classes.button}
            onClick={() => setRequestIntroModalOpen(true)}
            disabled={!source?.email}>
            {'Request intro...'}
        </Button>
        {requestIntroModalOpen && (
            <IntroductionRequestModal
                isOpen={requestIntroModalOpen}
                workspace={workspace}
                dashboard={dashboard}
                onClose={() => setRequestIntroModalOpen(false)} />
        )}
    </>);
};

export default RequestIntroButton;
